/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileAccessResponseBody
 */
export interface FileAccessResponseBody {
    /**
     * 
     * @type {string}
     * @memberof FileAccessResponseBody
     */
    url: string;
}

/**
 * Check if a given object implements the FileAccessResponseBody interface.
 */
export function instanceOfFileAccessResponseBody(value: object): value is FileAccessResponseBody {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function FileAccessResponseBodyFromJSON(json: any): FileAccessResponseBody {
    return FileAccessResponseBodyFromJSONTyped(json, false);
}

export function FileAccessResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileAccessResponseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function FileAccessResponseBodyToJSON(json: any): FileAccessResponseBody {
    return FileAccessResponseBodyToJSONTyped(json, false);
}

export function FileAccessResponseBodyToJSONTyped(value?: FileAccessResponseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

